import React from "react";
import Typography from "@material-ui/core/Typography";


class NetworkInfo extends React.Component {
    render() {
        return (
            <span>
            {navigator.onLine === true &&
            <span>
                                    {navigator.connection &&
                                    <Typography align={"right"} variant='caption'>
                                        Effective Internet Type: {navigator.connection.effectiveType}
                                        &nbsp; | &nbsp; Bandwidth : {navigator.connection.downlink} Mbps
                                    </Typography>}
                                </span>}
                {navigator.onLine === false &&
                <Typography align={"right"} variant='caption'>Offline</Typography>}
            </span>
        )
    }
}

export default NetworkInfo;
